import { defineComponent as _defineComponent } from 'vue'
import CountrySwitcher from '@/components/thg/CountrySwitcher.vue';
    import { useRoute, useRouter } from 'vue-router/composables';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGHeader',
  setup(__props) {

    const route = useRoute();
    const router = useRouter();

    const title = document.title;

    // reload the current page
    const reload = () => router.go(0);

    /**
     * Disable country switcher on several views (single car/user and user's cars)
     */
    function disableCountrySwitcher(): boolean {
        const routes = ['thgusercarslist', 'thgcar', 'thguser', 'thgco2equivalent'];

        return routes.includes(route.name as string);
    }

return { __sfc: true,route, router, title, reload, disableCountrySwitcher, CountrySwitcher }
}

})